module.exports = __webpack_public_path__ + "static/img/2.2706a48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/eng/2.png
// module id = JV6P
// module chunks = 0